import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ButtonModule } from '../button/index';
import { GenericModule } from '../generic/index';
import { MediaModule } from '../media/index';

import { ListComponent } from './list.component';
import { ListItemComponent } from './components/item/item.component';
import { ListSubtitleComponent, ListHeadingSubtitleComponent } from './components/subtitle/subtitle.component';
import { ListTitleComponent, ListHeadingTitleComponent } from './components/title/title.component';

export { ListComponent } from './list.component';
export { ListItemComponent } from './components/item/item.component';
export { ListSubtitleComponent, ListHeadingSubtitleComponent } from './components/subtitle/subtitle.component';
export { ListTitleComponent, ListHeadingTitleComponent } from './components/title/title.component';

@NgModule({
  declarations: [
    ListComponent,
    ListItemComponent,
    ListSubtitleComponent,
    ListHeadingSubtitleComponent,
    ListTitleComponent,
    ListHeadingTitleComponent
  ],
  imports: [
    CommonModule,

    ButtonModule,
    GenericModule,
    MediaModule
  ],
  exports: [
    ListComponent,
    ListItemComponent,
    ListSubtitleComponent,
    ListHeadingSubtitleComponent,
    ListTitleComponent,
    ListHeadingTitleComponent
  ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class ListModule {}
